import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  type CardProps,
  Chip,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { type FC, useState } from "react";
import { AssetPreview } from "../message/editor/plugins/toolbar/content-library/asset-preview";
import type { Asset } from "./server/digital-asset-service";
import LocalOfferOutlined from "@mui/icons-material/LocalOfferOutlined";

export const AssetCard: FC<
  {
    asset: Asset;
    selected?: boolean;
    disableZoomIcon?: boolean;
    designer?: string | null;
  } & CardProps
> = ({ asset, selected, disableZoomIcon = false, designer, ...props }) => {
  const [hover, setHovering] = useState<boolean>(false);

  return (
    <Card
      variant="outlined"
      {...props}
      sx={selected ? { borderWidth: "4px", borderColor: "primary.main" } : {}}
    >
      <CardActionArea
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
      >
        <AssetPreview
          asset={asset}
          height="200px"
          iconFontSize={120}
          showPreviewIcon={Boolean(selected && hover && !disableZoomIcon)}
          videoPlayer={false}
          designer={designer}
        />
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="subtitle1" noWrap textOverflow="ellipsis">
              {asset.title}
            </Typography>
            {asset.content_type && (
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Chip
                  label={asset.content_type}
                  data-testid={`${asset.content_type}-${asset.title}`}
                />
                {asset.tags && asset.tags.length > 0 && (
                  <Tooltip
                    title={
                      <Box>
                        {asset.tags.map((tag, index) => (
                          <span key={index}>
                            {tag}
                            <br />
                          </span>
                        ))}
                      </Box>
                    }
                    arrow
                  >
                    <LocalOfferOutlined sx={{ fontSize: "16px", color: "text.secondary" }} />
                  </Tooltip>
                )}
              </Stack>
            )}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
